"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.getSubjectKeys = getSubjectKeys;
var _hivemindCommon = require("@godaddy/hivemind-common");
var _switchboardWrapper = _interopRequireDefault(require("./switchboard-wrapper"));
var _apiKeys = require("./api-keys");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var HivemindClient = exports["default"] = /*#__PURE__*/function () {
  function HivemindClient(_ref) {
    var _window$switchboardPr;
    var app = _ref.app,
      cspKey = _ref.cspKey,
      env = _ref.env,
      switchboardWrapper = _ref.switchboardWrapper,
      _ref$switchboardOptio = _ref.switchboardOptions,
      _ref$switchboardOptio2 = _ref$switchboardOptio === void 0 ? {} : _ref$switchboardOptio,
      _ref$switchboardOptio3 = _ref$switchboardOptio2.preloadLocation,
      switchboardPreloadLocation = _ref$switchboardOptio3 === void 0 ? '__switchboardCachePreload' : _ref$switchboardOptio3,
      subject = _ref.subject;
    _classCallCheck(this, HivemindClient);
    (0, _hivemindCommon.validateApp)(app);
    this._app = app;
    this._cspKey = cspKey !== null && cspKey !== void 0 ? cspKey : _apiKeys.cspKeys[env];
    if (!this._cspKey) {
      console.warn('Could not determine a CSP API key; experimentation events are disabled. You must provide either a cspKey or env config property.');
    }
    this._subject = subject;
    this._switchboardWrapper = switchboardWrapper !== null && switchboardWrapper !== void 0 ? switchboardWrapper : new _switchboardWrapper["default"]({
      settings: (_window$switchboardPr = window[switchboardPreloadLocation]) !== null && _window$switchboardPr !== void 0 ? _window$switchboardPr : []
    });
  }
  _createClass(HivemindClient, [{
    key: "ready",
    get: function get() {
      return Promise.resolve();
    }
  }, {
    key: "getCohorts",
    value: function getCohorts(_ref2) {
      var _ref2$experiments = _ref2.experiments,
        experiments = _ref2$experiments === void 0 ? [] : _ref2$experiments,
        _ref2$labels = _ref2.labels,
        labels = _ref2$labels === void 0 ? [] : _ref2$labels,
        _ref2$attributes = _ref2.attributes,
        attributes = _ref2$attributes === void 0 ? {} : _ref2$attributes,
        _ref2$windowOverride = _ref2.windowOverride,
        windowOverride = _ref2$windowOverride === void 0 ? window : _ref2$windowOverride;
      var experimentsMetadata;
      if (experiments.length) {
        experimentsMetadata = this._switchboardWrapper.getExperimentsById(experiments);
      } else if (labels.length) {
        experimentsMetadata = this._getExperimentsByLabel(labels);
        experiments = Object.keys(experimentsMetadata);
      } else {
        console.log('No experiments or labels provided');
        experimentsMetadata = {};
      }
      return this._getCohorts({
        experimentsMetadata: experimentsMetadata,
        experiments: experiments,
        attributes: attributes,
        windowOverride: windowOverride
      });
    }
  }, {
    key: "_getCohorts",
    value: function _getCohorts(_ref3) {
      var _ref3$experimentsMeta = _ref3.experimentsMetadata,
        experimentsMetadata = _ref3$experimentsMeta === void 0 ? {} : _ref3$experimentsMeta,
        _ref3$experiments = _ref3.experiments,
        experiments = _ref3$experiments === void 0 ? [] : _ref3$experiments,
        _ref3$attributes = _ref3.attributes,
        attributes = _ref3$attributes === void 0 ? {} : _ref3$attributes,
        _ref3$windowOverride = _ref3.windowOverride,
        windowOverride = _ref3$windowOverride === void 0 ? window : _ref3$windowOverride;
      var switchboardExperiments = {};
      var switchboardExperimentIds = [];
      var ineligibleExperiments = [];
      var _iterator = _createForOfIteratorHelper(experiments),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var experiment = _step.value;
          var meta = experimentsMetadata[experiment];
          if (meta) {
            switchboardExperimentIds.push(experiment);
            switchboardExperiments[experiment] = meta;
          } else {
            ineligibleExperiments.push(experiment);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var switchboardAttributes = _objectSpread(_objectSpread({}, this._subject), {}, {
        // Switchboard rules use visitorId instead of visitorGuid
        visitorId: this._subject[_hivemindCommon.hivemindConstants.idTypes.VISITOR_GUID]
      }, attributes);
      var allocations = switchboardExperimentIds.length ? this._switchboardWrapper.getCohortAllocations({
        experiments: switchboardExperimentIds,
        attributes: switchboardAttributes
      }) : {};
      this._logSwitchboardCohorts({
        window: windowOverride,
        experiments: switchboardExperiments,
        cohortAllocations: allocations,
        attributes: switchboardAttributes
      });
      var cohortAllocations = (0, _hivemindCommon.updateCohortAllocationsWithEid)(allocations, this._app);
      return {
        cohorts: _objectSpread(_objectSpread({}, cohortAllocations), (0, _hivemindCommon.generateDefaultAllocations)(ineligibleExperiments))
      };
    }
  }, {
    key: "_logSwitchboardCohorts",
    value: function _logSwitchboardCohorts(_ref4) {
      var _this = this;
      var window = _ref4.window,
        experiments = _ref4.experiments,
        cohortAllocations = _ref4.cohortAllocations,
        attributes = _ref4.attributes;
      var events = Object.entries(cohortAllocations).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          experimentId = _ref6[0],
          alloc = _ref6[1];
        return [experimentId, alloc, experiments[experimentId]];
      }).filter(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 3),
          alloc = _ref8[1],
          experiment = _ref8[2];
        return alloc.cohortId !== 'ineligible' && experiment.subjectIdType;
      }).map(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 3),
          experimentId = _ref10[0],
          alloc = _ref10[1],
          subjectIdType = _ref10[2].subjectIdType;
        return {
          schemaId: 'urn:shared:user:event:/appconfig/id-percentage-evaluation/v1',
          data: {
            callingService: _this._app,
            eventCreationTimestamp: new Date().toISOString(),
            fqAppId: 'hivemind',
            setting: experimentId,
            settingValue: JSON.stringify(alloc),
            percentageIdType: subjectIdType,
            percentageId: attributes[subjectIdType]
          }
        };
      });
      if (!events.length) {
        return;
      }
      window._signalsDataLayer = window._signalsDataLayer || [];
      window._signalsDataLayer.push({
        schema: 'add_micro_events',
        data: {
          apiKey: this._cspKey,
          schemaId: 'urn:shared:user:events:/v1',
          events: events
        }
      });
    }
  }, {
    key: "getExperiments",
    value: function getExperiments() {
      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref11$labels = _ref11.labels,
        labels = _ref11$labels === void 0 ? [] : _ref11$labels;
      var experiments = labels.length ? this._getExperimentsByLabel(labels) : this._getAllExperiments();
      return Object.values(experiments);
    }
  }, {
    key: "_getAllExperiments",
    value: function _getAllExperiments() {
      return this._switchboardWrapper.getExperiments();
    }
  }, {
    key: "_getExperimentsByLabel",
    value: function _getExperimentsByLabel(labels) {
      // TODO: Add support for loading Switchboard experiments by label
      return Object.entries(this._getAllExperiments()).reduce(function (mapping, _ref12) {
        var _ref13 = _slicedToArray(_ref12, 2),
          id = _ref13[0],
          metadata = _ref13[1];
        if (labels.every(function (label) {
          var _metadata$labels;
          return metadata === null || metadata === void 0 || (_metadata$labels = metadata.labels) === null || _metadata$labels === void 0 ? void 0 : _metadata$labels.includes(label);
        })) mapping[id] = metadata;
        return mapping;
      }, {});
    }
  }, {
    key: "getParameterValue",
    value: function getParameterValue(_ref14) {
      var parameter = _ref14.parameter,
        defaultValue = _ref14.defaultValue,
        _ref14$attributes = _ref14.attributes,
        attributes = _ref14$attributes === void 0 ? {} : _ref14$attributes,
        _ref14$windowOverride = _ref14.windowOverride,
        windowOverride = _ref14$windowOverride === void 0 ? window : _ref14$windowOverride;
      var parameterExperiments = this._getExperimentsByLabel([this._app, _hivemindCommon.hivemindConstants.PARAMETER_LABEL]);
      var matchingExperimentsMetadata = Object.entries(parameterExperiments).reduce(function (mapping, _ref15) {
        var _ref16 = _slicedToArray(_ref15, 2),
          id = _ref16[0],
          metadata = _ref16[1];
        if (Object.values(metadata.cohortData).some(function (cohortMetadata) {
          return parameter in cohortMetadata;
        })) {
          mapping[id] = metadata;
        }
        return mapping;
      }, {});
      var matchingExperiments = Object.keys(matchingExperimentsMetadata);
      var numMatching = matchingExperiments.length;
      if (numMatching === 1) {
        var _this$_getCohorts = this._getCohorts({
            experimentsMetadata: matchingExperimentsMetadata,
            experiments: matchingExperiments,
            attributes: attributes,
            windowOverride: windowOverride
          }),
          cohorts = _this$_getCohorts.cohorts;
        var cohort = cohorts[matchingExperiments[0]];
        var cohortData = cohort.data;
        return {
          parameterValue: parameter in cohortData ? cohortData[parameter] : defaultValue,
          cohortId: cohort.cohortId,
          experimentId: matchingExperiments[0]
        };
      } else if (numMatching > 1) {
        console.log('Multiple experiments containing the same parameter definition.');
      }
      return {
        parameterValue: defaultValue,
        cohortId: null,
        experimentId: null
      };
    }
  }]);
  return HivemindClient;
}();
function getSubjectKeys(subject) {
  var subjectKeys = {};
  Object.entries(subject).forEach(function (_ref17) {
    var _ref18 = _slicedToArray(_ref17, 2),
      idType = _ref18[0],
      id = _ref18[1];
    subjectKeys[idType] = (0, _hivemindCommon.getSubjectKey)({
      idType: idType,
      id: id
    });
  });
  return subjectKeys;
}